<template>
  <div class="row">
    <div class="col-lg-12">
      <loader v-if="!isLoaded"></loader>
      <h3 class="page-title">#{{subscription.id}}</h3>

      <div class="info-block">
        <div class="row" v-if="subscription">
          <div class="col-md-4">
            <dl>
              <dt>{{'subscription.start_date' | trans}}:</dt>
              <dd v-if="subscription.startedAt">{{subscription.startedAt.date | toLocaleDate}}</dd>
              <dt>{{'subscription.end_date' | trans}}:</dt>
              <dd v-if="subscription.finishedAt">{{subscription.finishedAt.date | toLocaleDate}}</dd>
            </dl>
          </div>
          <div class="col-md-4">
            <dl>
              <dt>{{'profile.client_count' | trans}}:</dt>
              <dd>{{subscription.clientCount}}</dd>
              <dt v-if="subscription.cost">{{'profile.price' | trans}}:</dt>
              <dd v-if="subscription.cost">{{subscription.cost}}</dd>
              <dt>{{'profile.status' | trans}}:</dt>
              <dd>{{subscription.status}}</dd>
            </dl>
          </div>

        </div>
      </div>
      <form novalidate class="mt-4">
        <div class="row">
          <div class="col-12">
            <mdc-textfield id="comment"
                           :class="{'is-invalid': errors.has('comment')}"
                           ref="comment"
                           :label="'subscription.add_comment' | trans"
                           type="text"
                           multiline
                           v-validate="'required'"
                           rows="2"
                           name="comment"
                           v-model="comment"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.comment' | trans"/>
            <span class="invalid-feedback" v-if="errors.has('comment')">
                                    <strong>{{ errors.first('comment') }}</strong>
        </span>
          </div>
        </div>

      <div class="form-group row">
        <div class="col-md-12 text-right">

          <button type="submit"
                  class="btn btn-primary btn-sm"
                  @click.prevent="leaveComment">
            {{'buttons.send' | trans}}
          </button>
        </div>
      </div>
      </form>
      <table-view
          :options="commentListOptions"
          :isLoaded=isLoaded
          :isChange=isChange
          :isList=true>
      </table-view>
    </div>

  </div>
</template>

<script>

  import Manager from '../api/Manager';
  import TableView from '../../../common/table/components/TableView';
  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import moment from 'moment';

  export default {
    name: 'Profile',
    props: {
      id: {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        isChange: false,
        subscription: {},
        isLoaded: true,
        comment: null,
        commentListOptions: {
          filterable: false,
          sortable: [],
          debounce: 1000,
          skin: 'table table-sm table-heading-hide',
          listRow: {
            user:{
              headings: lang.get('user.user'),
              hasTemplate: true,
            },
            create_date:{
              headings: lang.get('subscription.create_date'),
              hasTemplate: true,
            },
            text:{
              headings: '',
              hasTemplate: false,
            },
          },
          templates: {
            user: this.userTemplates,
            create_date: this.createDate
          },
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total,
            };
          },
          texts: {
            filter: '',
            filterPlaceholder: lang.get(
              'user.type_the_therapist_name_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          perPage: 10,
        },
      };
    },

    created() {
      this.getSubscriptionInfo();
      this.markCommentAsViewed();
    },
    components: {
      TableView, Loader
    },
    methods: {

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      userTemplates(h, row) {
        return row.user.name;
      },

      createDate(h, row) {
        return this.toLocaleDate(row.create_date);
      },

      async requestFunction(data) {
        let response = await Manager.getSubscriptionComments(this.id, data.limit, data.page);
        return response;
      },
      async getSubscriptionInfo() {
        try {
          let response = await Manager.getSubscription(this.id);
          this.subscription = response.data.data;
        } catch (error) {
          if (error.status == 403) {
            this.$router.push({name: 'error'});
          }
        }
      },
      async markCommentAsViewed() {
        try{
          let response = await Manager.markCommentAsViewed(this.id);
        } catch (e) {

        }
      },
      async leaveComment() {
        let result = await this.$validator.validateAll();
        if (!result) {
          return;
        }
        try {
          this.isChange = false;
          this.isLoaded = false;
          let response = await Manager.comment(this.id, {id: this.id, text: this.comment});

        } catch (e) {
          console.error('Unknown API error occurred.');
        } finally {
          this.comment = null;
          this.isChange = true;
          this.isLoaded = true;
        }
      }
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/Subscription.vue